const selectors = {
  urlInput: '[data-share-url]',
  section: 'data-section-type',
  shareDetails: '[data-share-details]',
  shareSummary: '[data-share-summary]',
  shareCopy: '[data-share-copy]',
  shareButton: '[data-share-button]',
  closeButton: '[data-close-button]',
  successMessage: '[data-success-message]',
  shareHolder: '[data-share-holder]',
};

const classes = {
  hidden: 'is-hidden',
};

class ShareButton extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest(`[${selectors.section}]`);
    this.mainDetailsToggle = this.querySelector(selectors.shareDetails);
    this.shareButton = this.querySelector(selectors.shareButton);
    this.shareCopy = this.querySelector(selectors.shareCopy);
    this.shareSummary = this.querySelector(selectors.shareSummary);
    this.closeButton = this.querySelector(selectors.closeButton);
    this.successMessage = this.querySelector(selectors.successMessage);
    this.shareHolder = this.querySelector(selectors.shareHolder);
    this.urlInput = this.querySelector(selectors.urlInput);

    this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href;

    this.init();
    this.updateShareLink();
  }

  init() {
    if (navigator.share) {
      this.mainDetailsToggle.classList.add(classes.hidden);
      this.shareButton.classList.remove(classes.hidden);
      this.shareButton.addEventListener('click', () => {
        navigator.share({url: this.urlToShare, title: document.title});
      });
    } else {
      this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
      this.mainDetailsToggle.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            this.close();
          }
        });
      });
      this.shareCopy.addEventListener('click', this.copyToClipboard.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.container.addEventListener('keyup', this.keyboardEvents.bind(this));
    }
  }

  updateShareLink() {
    if (this.container.getAttribute(selectors.section) == 'product') {
      this.container.addEventListener('theme:variant:change', (event) => {
        if (event.detail.variant) {
          this.urlToShare = `${this.urlToShare.split('?')[0]}?variant=${event.detail.variant.id}`;
          if (this.urlInput) {
            this.urlInput.value = `${this.urlToShare.split('?')[0]}?variant=${event.detail.variant.id}`;
          }
        }
      });
    }
  }

  toggleDetails() {
    if (!this.mainDetailsToggle.open) {
      this.successMessage.classList.add(classes.hidden);
      this.successMessage.textContent = '';
      this.closeButton.classList.add(classes.hidden);
      this.shareCopy.focus();
    }
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.urlInput.value).then(() => {
      this.successMessage.classList.remove(classes.hidden);
      this.successMessage.textContent = theme.strings.successMessage;
      this.closeButton.classList.remove(classes.hidden);
      this.closeButton.focus();
    });
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.shareSummary.setAttribute('aria-expanded', false);
  }

  keyboardEvents(e) {
    if (e.code !== 'Escape') {
      return;
    }
    this.mainDetailsToggle.focus();
    this.close();
  }
}

export {ShareButton};
